export default __webpack_public_path__ + "static/media/firstSection.ac0e2ffa.png";